// extracted by mini-css-extract-plugin
export default {"date-time":"date-time_date-time__jQLWh","date-time--wrap":"date-time_date-time--wrap__P86GE"};